import React from 'react';
import { BeLogo } from './BeLogo';
export const TopBar = () => {
  return <div className="w-full bg-white flex justify-center items-center py-4 relative z-20" data-id="element-138">
      <BeLogo className="h-16 w-auto" data-id="element-139" />
    </div>;
};